<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;"></h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Ayarlar</li>
            <li class="breadcrumb-item active"><a routerLink="/dealer">Bayiler</a></li>
            <li class="breadcrumb-item active">Bayi Ekle</li>
        </ol>
    </div>
    <div class="container">
        <div class="card mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 class="m-0 font-weight-bold" style="color: #1A355E;">Bayi Ekle</h3>
            </div>
            <br>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="add()">
                    <div>
                        <fieldset>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Müşteri</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="customers$ | async" [style]="{'width': '100%'}"
                                                [virtualScroll]="true" [itemSize]="31" optionLabel="definitioN_"
                                                optionValue="logicalref" [filter]="true" [filterBy]="'code,definitioN_'"
                                                placeholder="Müşteri Seçimi Yapınız." [showClear]="true"
                                                formControlName="customerId">
                                                <ng-template let-customers pTemplate="item">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-3">
                                                            <span class="badge badge-info">
                                                                {{customers.code}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-9">
                                                            {{customers.definitioN_}}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('customerId').hasError('required')&& form.get('customerId').touched">Müşteri
                                            boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Bayi Adı</span></label>

                                    <div class="input-valid">
                                        <input pInputText type="txt" class="form-control" formControlName="dealerName"
                                            autofocus />
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('dealerName').hasError('required')&& form.get('dealerName').touched">Bayi
                                            Adı boş geçilemez!</small>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-12 text-right">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button pButton type="button" class="p-button-rounded p-button-danger"
                                        label="Vazgeç" routerLink="/dealer"></button>
                                    <button pButton type="submit" class="p-button-rounded p-button-success"
                                        label="Kaydet" [disabled]="!form.valid"></button>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>